<template>
  <div :class="$style.container">
    <div :class="$style.heading">
      <div :class="$style.text">{{ t('heading') }}</div>
    </div>
    <profile-notifications-list />
  </div>
</template>

<i18n>
{
  "ru": {
    "heading": "Настройка уведомлений"
  },
  "en": {
    "heading": "Notification settings"
  }
}
</i18n>

<script>
import ProfileNotificationsList from '~/components/profile/notifications/list'

export default {
  name: 'ProfileNotifications',
  components: {
    ProfileNotificationsList
  },
  setup() {
    const { t } = useI18n()
    return { t }
  }
}
</script>

<style lang="scss" module>
.container {
  background-color: color-get(--root-rgb-bg-card);
  border-radius: 2.4em;
  padding: 2.5em;

  @include down(sm) {
    border-radius: 0.8em;
  }
}

.heading {
  margin-bottom: 2em;

  .text {
    @include typo-get(subhead-m);
    text-transform: uppercase;
    color: color-get(--root-rgb-text-1);
  }
}
</style>
